var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDarts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipPath: "url(#darts_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.253 4.746a.565.565 0 0 0-.746-.048l-1.183.916-6.354 4.637a1.979 1.979 0 1 0 2.778 2.778l4.637-6.355.915-1.183a.566.566 0 0 0-.047-.745m.707-.708a1.565 1.565 0 0 0-2.065-.13l-1.172.907L2.37 9.452l-.006.004a2.979 2.979 0 1 0 4.18 4.18l.004-.006 4.637-6.355.907-1.172c.233-.3.349-.677.325-1.057"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.064-.031a2.53 2.53 0 0 1 2.529 2.438c.662.024 1.26.302 1.697.74a2.53 2.53 0 0 1-1.789 4.32h-2.709V6.465h2.709a1.53 1.53 0 0 0 0-3.061h-.2l-1.33 1.331-.708-.707 1.332-1.331v-.199a1.53 1.53 0 0 0-1.53-1.53m0 0a1.526 1.526 0 0 0-1.531 1.53v2.709h-1V2.499c0-.698.284-1.332.741-1.789a2.53 2.53 0 0 1 1.79-.741m-6.02 8.054 2.932 2.931-.707.707L4.338 8.73zM3.492 9.157l3.351 3.352-.707.707-3.351-3.351zm-.703 4.762L.685 16.021l-.707-.707 2.103-2.102z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "darts_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgDarts;